// ─── Template : CALQUE plein écran ────────────────────────────────
// Gabarit des surfaces qui doivent couvrir tout l'écran SANS être un <Modal> :
// scanner, « Où est-ce rangé ? »… On les empile ainsi AU-DESSUS d'une feuille
// déjà ouverte sans imbriquer deux <Modal> natifs (interdit sur iOS).
//
//   <Calque visible titre="Où est-ce rangé ?" onRetour={…} onFermer={…}>
//     …contenu…
//   </Calque>
//
// `onRetour` (optionnel) affiche une flèche ‹ à gauche ; `sombre` donne un fond
// noir (pour la caméra). Rendu en position absolue, zIndex/elevation élevés.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useUI } from '../theme/PreferencesUI';

const HIT = { top: 10, bottom: 10, left: 10, right: 10 };

export default function Calque({
  visible, titre, onRetour, onFermer, sombre = false, sansScroll = false, paddingTop, children,
}) {
  const UI = useUI();
  const insets = useSafeAreaInsets();
  const s = useMemo(() => makeStyles(UI, sombre), [UI, sombre]);
  if (!visible) return null;
  // Le calque peut couvrir tout l'écran (encoche/Dynamic Island incluse) : on
  // décale l'en-tête sous la zone de sécurité, sinon le titre et le ✕ passent
  // sous la barre système.
  const hautEntete = paddingTop != null ? paddingTop : insets.top + 12;
  return (
    <View style={[StyleSheet.absoluteFill, s.calque]}>
      <View style={[s.entete, { paddingTop: hautEntete }]}>
        {!!onRetour && (
          <TouchableOpacity onPress={onRetour} hitSlop={HIT}><Text style={s.chevron}>‹</Text></TouchableOpacity>
        )}
        <Text style={s.titre} numberOfLines={1}>{titre}</Text>
        {!!onFermer && (
          <TouchableOpacity onPress={onFermer} hitSlop={HIT}><Text style={s.close}>✕</Text></TouchableOpacity>
        )}
      </View>
      {sansScroll
        ? <View style={{ flex: 1 }}>{children}</View>
        : <ScrollView contentContainerStyle={s.corps}>{children}<View style={{ height: 30 }} /></ScrollView>}
    </View>
  );
}

const makeStyles = (UI, sombre) => StyleSheet.create({
  calque:  { backgroundColor: sombre ? '#000' : UI.bg, zIndex: 200, elevation: 40 },
  entete:  { flexDirection: 'row', alignItems: 'center', gap: 12, paddingHorizontal: 16, paddingBottom: 12,
             backgroundColor: sombre ? 'rgba(0,0,0,0.45)' : UI.card,
             borderBottomWidth: sombre ? 0 : 0.5, borderBottomColor: UI.border },
  chevron: { fontSize: 26, lineHeight: 28, color: sombre ? '#fff' : UI.accent, fontWeight: '300' },
  titre:   { flex: 1, fontSize: 18, fontWeight: '800', color: sombre ? '#fff' : UI.ink },
  close:   { fontSize: 20, color: sombre ? '#fff' : UI.accent },
  corps:   { padding: 16 },
});
